import MuiIconButton, { IconButtonProps } from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import makeStyles from "@mui/styles/makeStyles";

interface Props {
  tooltip?: string;
  icon: React.ReactNode;
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
  },
}));
export function IconButton(props: Props & IconButtonProps) {
  const classes = useStyles();

  const color = props.disabled ? "secondary" : "primary";

  return (
    <Tooltip title={props.tooltip ? <div>{props.tooltip}</div> : ""}>
      <span>
        <MuiIconButton color={color} {...props} className={classes.root}>
          {props.icon}
        </MuiIconButton>
      </span>
    </Tooltip>
  );
}
